const PassengerType = {
    INSTRUCTOR: "instructor",
    LICENSED: "licensed",
    MINOR: "minor",
    UNLICENSED: "unlicensed",
};

export default PassengerType;
